import { useLocalObservable } from 'mobx-react-lite';
import { useEffect } from 'react';

import Tasks from 'APP/Tasks';
import { ProjectUrls } from 'APP/packages/projectUrls/ProjectUrls';
import { storage } from 'APP/packages/storage';
import Entities from 'STORE';

interface IAppRouterPresenter {
  login(): Promise<void>;
  getUserConfirmation(message: string, callback: (isCofirmed: boolean) => void): Promise<void>;
}

export function useAppRouterPresenter(): IAppRouterPresenter {
  const presenter = useLocalObservable(() => ({
    async login(): Promise<void> {
      const isSuccess = await Tasks.authorization.refreshToken();

      Entities.authStore.finishFirstLogin();

      if (!ProjectUrls.isCorrectConfig) {
        storage.tenantRouting.remove();
        return;
      }
      if (!isSuccess) {
        await Tasks.authorization.logout();
      }
    },

    async getUserConfirmation(
      message: string,
      callback: (isCofirmed: boolean) => void
    ): Promise<void> {
      const isCofirmed = await Tasks.app.showConfirm({
        text: message,
      });

      callback(isCofirmed);
    },
  }));

  useEffect(() => {
    presenter.login();
  }, []);

  return presenter;
}
